<template>
	<div class="medication analysis">
		<div class="card">
			<h5>As Needed Adherence</h5>
			<el-table
				:data="orderedCompliance"
				:show-header="false"
				max-height="300px">
				<el-table-column label="Date" width="200">
					<template slot-scope="scope">
						<strong class="date">{{ formatDate(scope.row.time) }}</strong>
						&middot;
						<span class="date">{{ formatTime(scope.row.created) }}</span>
					</template>
				</el-table-column>

				<!-- Value -->
				<el-table-column label="Value" width="200">
					<template slot-scope="scope">
						<!-- <strong v-bind:class="['status', statusClass(scope.row.status)]">
							<i :class="statusIcon(scope.row.status)"></i>
							{{ statusText(scope.row.status) }}
						</strong> -->
						<span class="dosage" v-for="(amount, time) in scope.row.record">
							{{ time }} x{{ amount }}
						</span>
					</template>
				</el-table-column>

				<!-- Details -->
				<el-table-column label="Value">
					<template slot-scope="scope">

					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
import formatDate from '@/module/util/format-date'
import formatTime from '@/module/util/format-time'

export default {
	name: 'patient-medication-card-as-needed',

	props: {
		id: {
			type: String
		},
		medication: {
			type: Object
		}
	},

	methods: {
		formatDate,
		formatTime
	},

	computed: {
		orderedCompliance() {
			return this.medication.compliance.slice().sort((a, b) => (a.time - b.time))
		}
	}
}
</script>
<style lang="scss" scoped>
@import "../../component/table/style/analysis.scss";
.detail {
	color: $gray-color;
}
</style>
